import AccordionContainer from "../../Componant/Ui Kit/Accordion";

const Accordion = () => {
  return (
    <div className="page-body">
        <AccordionContainer/>
    </div>
  )
};

export default Accordion;
